import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ArabicHandleService {

  constructor() { }

  arabicManagement(lang: any) {
    if (lang === 'ar') {
      document.querySelector('html')?.setAttribute('dir', 'rtl');
      document.querySelector('html')?.setAttribute('lang', 'ar');

    }
    else {
      document.querySelector('html')?.setAttribute('dir', 'ltr');
      document.querySelector('html')?.setAttribute('lang', 'en');
    }
  }

  toggleLanguage() {
    let language = localStorage.getItem('lang') || 'en';
    let newLang = language === 'en' ? 'ar' : 'en';
    this.arabicManagement(newLang);
    localStorage.setItem('lang', newLang);
    let currentLanguage = newLang === 'ar' ? 'ar' : 'en';
    
    return currentLanguage;
  }



}
